import { render } from "./OrderProfile.vue?vue&type=template&id=47041123"
import script from "./OrderProfile.vue?vue&type=script&lang=js"
export * from "./OrderProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__